// Equality checks for state setters that rebuild a collection from props. Returning the
// current value when nothing changed lets React skip the re-render; a mount-time
// "sync from props" effect otherwise renders every card twice.

export function sameArrayItems<T>(
    current: readonly T[] | null | undefined,
    next: readonly T[] | null | undefined,
) {
    if (current === next) return true
    if (!current || !next || current.length !== next.length) return false
    return current.every((item, index) => item === next[index])
}

export function sameSetMembers<T>(current: ReadonlySet<T>, next: ReadonlySet<T>) {
    if (current === next) return true
    if (current.size !== next.size) return false
    for (const item of next) if (!current.has(item)) return false
    return true
}
